import { useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from 'components/Button'
import PublicLayout from 'components/Layouts/public'
import { OrderSuccessRoute } from 'constants/routes'
import APIS from 'constants/api'
// import { LoaderContext } from 'context/loader'
import { SnackBarContext } from 'context/SnackBarContext'
import usePost from 'hooks/usePost'
import RazorpayPayment from 'views/RazorpayPayment'
import PaymentOrderDetails from 'views/PaymentOrderDetails'
import BackArrow from 'assets/svg/BackArrow'
import { CommonStyle } from 'styles/pages/Common'
import { CheckoutWrappers, BackWrapper, CheckoutButtonWrapper, CheckoutPageWrapper } from 'styles/pages/MyAccount'
import PayuPayment from 'views/PayuPayment'

const CheckoutPage = () => {
  const [selectedRadioValue, setSelectedRadioValue] = useState<string | null>(null)
  const [prepaidData, setPrepaidData] = useState<any>()
  const [prepaidError, setPrepaidError] = useState<any>()
  const navigate = useHistory()
  const customerId = localStorage.getItem('customerId')
  const { setShowSnackBar } = useContext(SnackBarContext)
  const { mutateAsync } = usePost()
  const history = useHistory()

  const handleBack = () => {
    history.go(-1) // Navigates two steps back in the history stack
  }

  const handlePrepaidClickPay = async () => {
    try {
      const res = await mutateAsync({
        url: `${APIS.PLACED_ORDER_PREPAID}`,
        payload: {
          attchedFile: '',
          message: '',
          coinAmount: 0,
          moneyAmount: 0,
          paymentCategory: null,
          customerId: customerId,
          loyaltyCoin: '0',
          customerOrderedCurrency: 'INR',
          plotch_referral: '',
          plotch_referral_key: '',
          attribution_instance_id: '',
        },
      })
      if (res) {
        localStorage.setItem('orderId', res.d.orderId)
        setPrepaidData(res)
      }
    } catch (error: any) {
      if (error.response) {
        const res = error.response.data
        if (res.d) {
          setPrepaidError(res.d?.productList)
        }
      }
    }
  }

  const handleCodClickPay = async () => {
    try {
      const res = await mutateAsync({
        url: `${APIS.PLACED_ORDER_COD}`,
        payload: {
          action: 'placeCodOrder',
          loyaltyCoin: '0',
          slot: '',
          attchedFile: '',
          message: '',
          coinAmount: 0,
          moneyAmount: 0,
          prepaid: 0,
          customerOrderedCurrency: 'INR',
          plotch_referral: '',
          plotch_referral_key: '',
          attribution_instance_id: '',
          customerId: customerId,
        },
      })
      if (res) {
        localStorage.setItem('orderId', res.d.orderId)
        setShowSnackBar({ open: true, message: `${res.m}`, severity: '' })
        navigate.push(OrderSuccessRoute.path)
      }
    } catch (error: any) {
      if (error.response) {
        const res = error.response.data
        if (res.d) {
          setPrepaidError(res.d?.productList)
        }
      }
    }
  }

  const handleClickPay = () => {
    if (selectedRadioValue === 'cod') {
      handleCodClickPay()
    } else {
      handlePrepaidClickPay()
    }
  }

  return (
    <PublicLayout>
      <CheckoutPageWrapper>
        <CheckoutWrappers>
          <CommonStyle>
            <BackWrapper className="padding_full_page" onClick={handleBack}>
              <BackArrow />
              <div className="h1b">PAYMENT</div>
            </BackWrapper>
          </CommonStyle>
          <PaymentOrderDetails
            selectedRadioValue={selectedRadioValue}
            setSelectedRadioValue={setSelectedRadioValue}
            prepaidError={prepaidError}
            setPrepaidError={setPrepaidError}
          />
          <CheckoutButtonWrapper>
            <Button
              label="PAY NOW"
              type="submit"
              className="small"
              onClick={selectedRadioValue ? handleClickPay : undefined}
              variant={selectedRadioValue ? 'contained' : 'disabled'}
            />
          </CheckoutButtonWrapper>
        </CheckoutWrappers>
        {prepaidData?.d?.gateway && prepaidData?.d?.gateway == 'razorpay' ? (
          <RazorpayPayment prepaidData={prepaidData} />
        ) : prepaidData?.d?.gateway == 'payu' || prepaidData?.d?.gateway == 'ccavenue' ? (
          <PayuPayment prepaidData={prepaidData} />
        ) : (
          <></>
        )}
      </CheckoutPageWrapper>
    </PublicLayout>
  )
}

export default CheckoutPage
